import { Pipe, PipeTransform } from '@angular/core';
import { WarehouseTransferType } from '../enums/warehouse-transfer-type';
import { WarehouseTransfer } from '../models/entities/warehouse-transfer';


@Pipe({
  name: 'warehouse-transfer-pipe'
})

export class WarehouseTransferPipe implements PipeTransform {
  
  constructor(){}

    
progressLevels = [  
  {'id' : '0',  'name' : '  0 -  Nouveau'                  },
  {'id' : '5',  'name' : '  5 -  Réjeté'                   },
  {'id' : '10', 'name' : ' 10 -  Soumis au Magasinier'     },
  {'id' : '12', 'name' : ' 12 -  Demande de changement'    },
  {'id' : '15', 'name' : ' 15 -  Transféré à ERP'          },
  {'id' : '20', 'name' : ' 20 -  Traité par Magasinier'    },
  {'id' : '30', 'name' : ' 30 -  Ajusté'                   },
  {'id' : '35', 'name' : ' 35 -  Facturé'                  },
  {'id' : '40', 'name' : ' 40 -  Soumis au vendeur'        },
  {'id' : '45', 'name' : ' 45 -  Synchronisé'              },
  {'id' : '50', 'name' : ' 50 -  Acceptée '                },
]   


  

  transform(warehouseTransfer: WarehouseTransfer, field: string): any {
    let result = warehouseTransfer[field];
    

    
    if (field == 'transferType') {
      let type = "?"

      switch (result) {
        case  WarehouseTransferType.tt_regular:
          type = "Conventionnel";
          break;
      
        case  WarehouseTransferType.tt_presales:
          type = "Prévente";
          break;

        case  WarehouseTransferType.tt_regular_mobile:
          type = "Mobile";
          break;
      
        case  WarehouseTransferType.tt_purchase:
          type = "Achat";
          break;

        case  WarehouseTransferType.tt_direct:
          type = "Entrée/Sortie";
          break;

        case  WarehouseTransferType.tt_sr_to_sr_load:
          type = "Vendeur à Vendeur";
          break;
      
        case  WarehouseTransferType.tt_sr_to_sr_unload:
          type = "Vendeur à Vendeur";
          break;

        case  WarehouseTransferType.tt_handover_load:
          type = "Shift camion";
          break;
      
        case  WarehouseTransferType.tt_handover_unload:
          type = "Shift camion";
          break;

        default:
          break;
      }

      result = "<div class='label-blue'> " + type + " </div>";
    }

    if (field == 'returnWt') {
        let html = "<div class='multi-labels'>";
        if  (result)  {
          html += "<div class='label-orange'> Retour </div>"
        }  

        if (warehouseTransfer.canceled) {
          html += "<div class='label-red'> Annulée </div>"
        }
        html += "</div>";
        result = html;
    }


    if (field == 'progressLevel') {
      if  (result == this.progressLevels[0].id )  result = "<div class='label-blue'> "    + this.progressLevels[0].name + " </div>";
      if  (result == this.progressLevels[1].id )  result = "<div class='label-red'> "     + this.progressLevels[1].name + " </div>";
      if  (result == this.progressLevels[2].id )  result = "<div class='label-orange'> "  + this.progressLevels[2].name + " </div>";
      if  (result == this.progressLevels[3].id )  result = "<div class='label-red'> "     + this.progressLevels[3].name + " </div>";
      if  (result == this.progressLevels[4].id )  result = "<div class='label-orange'> "  + this.progressLevels[4].name + " </div>";
      if  (result == this.progressLevels[5].id )  result = "<div class='label-orange'> "  + this.progressLevels[5].name + " </div>";
      if  (result == this.progressLevels[6].id )  result = "<div class='label-green'> "   + this.progressLevels[6].name + " </div>";
      if  (result == this.progressLevels[7].id )  result = "<div class='label-blue'> "    + this.progressLevels[7].name + " </div>";
      if  (result == this.progressLevels[8].id )  result = "<div class='label-gray'> "    + this.progressLevels[8].name + " </div>";
      if  (result == this.progressLevels[9].id )  result = "<div class='label-orange'> "  + this.progressLevels[9].name + " </div>";
      if  (result == this.progressLevels[10].id)  result = "<div class='label-green'> "   + this.progressLevels[10].name + " </div>";
    }

    return result;
  }
}
